"use client"

import { Table } from "@tanstack/react-table"
import { X } from "lucide-react"
import { ReactNode } from "react"

import { Button } from "@/components/ui/button"
import { DataTableViewOptions } from "./data-table-view-options"

interface DataTableToolbarProps<TData> {
  table: Table<TData>
  children?: ReactNode
  leftActions?: ReactNode
  rightActions?: ReactNode
  hasCustomFilters?: boolean
  onResetFilters?: () => void
}

export function DataTableToolbar<TData>({
  table,
  children,
  leftActions,
  rightActions,
  hasCustomFilters = false,
  onResetFilters: onFiltersReset,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0 || hasCustomFilters;

  return (
    <div className="flex flex-col min-[1100px]:flex-row gap-2 items-center justify-between">
      <div className="flex flex-1 items-center gap-2">
        {leftActions}
        {children}
        {isFiltered && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              table.resetColumnFilters()
              onFiltersReset?.()
            }}
          >
            Reset
            <X />
          </Button>
        )}
      </div>
      <div className="flex items-center gap-2">
        {rightActions}
        <DataTableViewOptions table={table} />
      </div>
    </div>
  )
}
